import { I18n } from 'i18n-js';
import en from 'i18n-js/json/en.json';

const customFormats = {
  en: {
    date: {
      formats: {
        time: '%H:%M',
      },
    },
    time: {
      formats: {
        date: '%b %d, %Y',
        date_month: '%d %b',
        long2: '%b %d, %Y %H:%M',
        month: '%b %Y',
        time: '%H:%M',
        time_date: ' %H:%M - %b %d, %Y',
        us: '%m/%d/%Y %I:%M %p',
      },
    },
  },
};
const i18n = new I18n();

i18n.store(en);
i18n.store(customFormats);

export default i18n;
